class CarouselSlider extends HTMLElement {
	#desktopQuery = window.matchMedia("(min-width: 48rem)");
	#teardown = null;

	connectedCallback() {
		this.#desktopQuery.addEventListener("change", this.#handleViewportChange);

		if (this.#desktopQuery.matches) {
			this.#activate();
		}
	}

	async #activate() {
		if (this.#teardown) {
			return;
		}

		const { initCarouselSlider } = await import("./carousel-slider-desktop.js");
		this.#teardown = initCarouselSlider(this);
	}

	#deactivate() {
		if (this.#teardown) {
			this.#teardown();
			this.#teardown = null;
		}
	}

	#handleViewportChange = (event) => {
		if (event.matches) {
			this.#activate();
		} else {
			this.#deactivate();
		}
	};
}

if (!customElements.get("finstral-carousel-slider")) {
	customElements.define("finstral-carousel-slider", CarouselSlider);
}
